import script from "./newDriverbutton.vue?vue&type=script&setup=true&lang=js"
export * from "./newDriverbutton.vue?vue&type=script&setup=true&lang=js"

import "./newDriverbutton.vue?vue&type=style&index=0&id=5850e2cd&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5850e2cd"]])

export default __exports__